import React from 'react';
import { Rocket, Award, Users, Phone } from 'lucide-react';
import Container from './Container';
import Button from './Button';

const features = [
  {
    icon: Rocket,
    title: '10x Faster Results',
    description: 'AI-powered optimization that gets you ranking faster'
  },
  {
    icon: Award,
    title: 'Industry Leading',
    description: 'Trusted by top roofing companies nationwide'
  },
  {
    icon: Users,
    title: '24/7 Support',
    description: 'Expert assistance whenever you need it'
  }
];

const Hero = () => {
  return (
    <div className="relative bg-gradient-to-b from-blue-50 to-white pt-32 pb-20">
      <Container>
        <div className="text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            Dominate Local SEO with
            <span className="text-blue-600"> OTTO</span>
          </h1>
          <p className="text-xl text-gray-600 mb-4 max-w-3xl mx-auto">
            Powerful AI-driven SEO tools designed specifically for roofing companies.
            Get more leads, rank higher, and grow your business with Search Atlas.
          </p>
          
          <a href="tel:9192714871" className="flex items-center justify-center text-2xl text-blue-600 font-bold mb-8 hover:text-blue-700">
            <Phone className="h-6 w-6 mr-2" />
            (919) 271-4871
          </a>
          
          <div className="flex flex-col sm:flex-row justify-center gap-4 mb-16">
            <Button className="text-lg px-8 py-4">
              Start Your Free Trial
            </Button>
            <Button 
              variant="secondary" 
              className="text-lg px-8 py-4"
            >
              Watch Demo
            </Button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            {features.map((feature, index) => (
              <div key={index} className="flex flex-col items-center">
                <div className="bg-blue-100 p-3 rounded-full mb-4">
                  <feature.icon className="h-6 w-6 text-blue-600" />
                </div>
                <h3 className="text-xl font-semibold mb-2">{feature.title}</h3>
                <p className="text-gray-600">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Hero;